export default function setCategoriesSwiper() {
  const categoriesSlider = new Swiper('[data-categories] .swiper', {
    slidesPerView: 2.1,
    spaceBetween: 24,
    speed: 1000,
    watchOverflow: true,
    centerInsufficientSlides: true,
    lazy: {
      checkInView: true,
      loadPrevNext: false,
      loadOnTransitionStart: true,
    },
    pagination: {
      el: '[data-categories] .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 6,
      },
    },
  });
}
